import * as React from 'react';
import type { SpinnerProps } from '@components/atoms/spinner/types';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { useAppTheme } from '@theme';

const Atom: React.FC<SpinnerProps> = ({ size, color, className, style, sx }) => {
    const theme = useAppTheme();

    return (
        <Stack spacing={2} direction='row' className={className} sx={sx} style={style}>
            <CircularProgress size={size} style={{ color: color || theme.palette.primaryA1 }} />
        </Stack>
    );
};

export const Spinner = styled(Atom)({});
